import { Capacitor } from '@capacitor/core';
import { versionAtLeast } from './shellVersionCore';

export { versionAtLeast } from './shellVersionCore';

let cached: Promise<string | null> | null = null;

/**
 * The native shell's marketing version (CFBundleShortVersionString /
 * versionName) via @capacitor/app, null on the web or when the shell cannot
 * tell. The shells load the web app from the server, so new web code runs in
 * old binaries — anything that needs a native change (a URL scheme, a plugin)
 * has to check the shell version before offering itself.
 */
export function getShellVersion(): Promise<string | null> {
  if (!Capacitor.isNativePlatform()) return Promise.resolve(null);
  if (!cached) {
    cached = (async () => {
      try {
        if (!Capacitor.isPluginAvailable('App')) return null;
        const { App } = await import('@capacitor/app');
        const info = await App.getInfo();
        return info.version || null;
      } catch {
        return null;
      }
    })();
  }
  return cached;
}

/** True when the running shell is at least `min` (unknown version = false). */
export async function shellAtLeast(min: string): Promise<boolean> {
  return versionAtLeast(await getShellVersion(), min);
}
